// frontend/modules/internal-account/components/InternalAccountList.tsx
import React from 'react';
import { Table, Tag, Space, Button, Tooltip } from 'antd';
import { EditOutlined, CloseOutlined } from '@ant-design/icons';
import { InternalAccountDTO } from '../stores/internal-account-store';
import dayjs from 'dayjs';

interface InternalAccountListProps {
    accounts: InternalAccountDTO[];
    isLoading: boolean;
    onEdit: (account: InternalAccountDTO) => void;
    onClose: (account: InternalAccountDTO) => void;
}

const InternalAccountList: React.FC<InternalAccountListProps> = ({
    accounts,
    isLoading,
    onEdit,
    onClose
}) => {
    // Table columns
    const columns = [
        {
            title: 'Branch',
            dataIndex: 'branch',
            key: 'branch',
            width: '8%'
        },
        {
            title: 'GL Number',
            dataIndex: 'glNo',
            key: 'glNo',
            width: '10%'
        },
        {
            title: 'Account Number',
            dataIndex: 'acNo',
            key: 'acNo',
            width: '10%'
        },
        {
            title: 'Account Name',
            dataIndex: 'acName',
            key: 'acName',
            width: '30%'
        },
        {
            title: 'Customer Number',
            dataIndex: 'custNo',
            key: 'custNo',
            width: '10%',
            render: (custNo: string) => custNo || '-'
        },
        {
            title: 'Opened Date',
            dataIndex: 'openedDate',
            key: 'openedDate',
            width: '12%',
            render: (date: string) => date ? dayjs(date).format('YYYY-MM-DD') : '-'
        },
        {
            title: 'Status',
            dataIndex: 'acStatus',
            key: 'acStatus',
            width: '10%',
            render: (status: string) => (
                <Tag color={status === 'A' ? 'green' : 'red'}>
                    {status === 'A' ? 'Active' : 'Closed'}
                </Tag>
            )
        },
        {
            title: 'Actions',
            key: 'actions',
            width: '10%',
            render: (_: any, record: InternalAccountDTO) => (
                <Space>
                    <Tooltip title="Edit">
                        <Button 
                            type="text" 
                            icon={<EditOutlined />} 
                            onClick={() => onEdit(record)} 
                            disabled={record.acStatus === 'C'}
                        />
                    </Tooltip>
                    {record.acStatus === 'A' && (
                        <Tooltip title="Close Account">
                            <Button 
                                type="text" 
                                danger 
                                icon={<CloseOutlined />} 
                                onClick={() => onClose(record)} 
                            />
                        </Tooltip>
                    )}
                </Space>
            )
        }
    ];

    return (
        <Table
            dataSource={accounts}
            columns={columns}
            rowKey={(record) => `${record.branch}-${record.glNo}-${record.acNo}`}
            loading={isLoading}
            pagination={{ pageSize: 10 }}
        />
    );
};

export default InternalAccountList;
